import { tns } from "tiny-slider/src/tiny-slider";

export function Carousel(element, options, autoplayOnVisible = false) {
  const sliders = document.querySelectorAll(element);

  function handleButton(button, target) {
    target.pause();
    target.goTo(button.dataset.dir);
    target.play();
  }

  function observe(item, slider) {
    const observer = new IntersectionObserver(
      item => {
        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap
        if (item[0].isIntersecting === true) {
          slider.play();
        } else {
          slider.pause();
        }
      },
      { threshold: [0], rootMargin: "-10% 0% 0% 0%" }
    );

    observer.observe(item);
  }

  function initSlider(item) {
    const buttons = item.querySelectorAll(".js-slider-button");
    const carousel = item.querySelector(".js-slider");
    if (item.dataset.autoplaySpeed) {
      options = {
        autoplayTimeout: item.dataset.autoplaySpeed,
        ...options
      };
    }
    const slider = tns({
      container: carousel,
      controls: false,
      arrowKeys: true,
      nav: false,
      ...options
    });
    buttons.forEach(button => {
      button.addEventListener("click", e => {
        e.preventDefault();
        handleButton(button, slider);
      });
    });

    if (autoplayOnVisible) {
      observe(item, slider);
    }
  }
  sliders.forEach(item => {
    initSlider(item);
  });
}

Carousel(
  ".js-carousel",
  {
    items: 1,
    autoplay: true,
    autoplayButtonOutput: true,
    autoplayButton: "#testimonials-autoplay",
    autoplayHoverPause: true,
    autoplayText: ["Start", "Pauza"],
    autoplayTimeout: 6000,
    autoplayPosition: "bottom",
    preventActionWhenRunning: true,
    autoHeight: true,
    responsive: {
      600: {
        autoHeight: false
      }
    }
  },
  true
);

Carousel(".js-clients", {
  items: 2,
  slideBy: "page",
  autoplay: false,
  autoplayButtonOutput: false,
  responsive: {
    576: {
      items: 3
    },
    768: {
      items: 4
    },
    992: {
      items: 5
    }
  }
});
